import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import {
  HeaderComponent,
  FooterComponent,
  LoadingIndicatorComponent,
  ToasterComponent,
  NavbarComponent,
} from '#components';
import { environment } from '#environments';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, NavbarComponent, FooterComponent, LoadingIndicatorComponent, ToasterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor() {
    const titleService = inject(Title);
    const baseTitle = titleService.getTitle();
    if (environment.envName !== 'prod') {
      const tag = environment.envName.toUpperCase();
      titleService.setTitle(`[${tag}] ${baseTitle}`);
    }
  }
}
